import useRoutePanelControl from './RoutePanelControl';

export default useRoutePanelControl;